import script from "./AppTour.vue?vue&type=script&setup=true&lang=js"
export * from "./AppTour.vue?vue&type=script&setup=true&lang=js"

import "./AppTour.vue?vue&type=style&index=0&id=aad6170e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aad6170e"]])

export default __exports__